import React from "react";
import "./Spinner.css";

const Spinner = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="spinner"
    >
      {/* Background Circle */}
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="#CB90FC"
        strokeWidth="8"
        fill="none"
        className="spinner-background"
      />
      {/* Traveling Stroke */}
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="#45185A"
        strokeWidth="8"
        fill="none"
        className="spinner-travel"
      />
    </svg>
  );
};

export default Spinner;
